import Link from 'next/link'
import styled from 'styled-components'
import { GsatReviewPost_PostFragment } from 'generated/graphql.community'
import { LINKAREER_ACADEMY_COMMUNITY_BASE_URL } from 'utils/config'
import ReviewItem from './ReviewItem.mobile'

interface CommunityReviewListMobileProps {
  reviewPosts: GsatReviewPost_PostFragment[]
}

const CommunityReviewListMobile = ({
  reviewPosts,
}: CommunityReviewListMobileProps) => {
  return (
    <StyledWrapper>
      {reviewPosts.map((postData) => {
        return (
          <Link
            href={{
              pathname: `${LINKAREER_ACADEMY_COMMUNITY_BASE_URL}/${postData.board?.slug}/${postData.id}`,
            }}
            key={postData.id}
          >
            <a>
              <ReviewItem
                postTitle={postData.title ?? ''}
                userNickname={postData.username ?? ''}
              />
            </a>
          </Link>
        )
      })}
    </StyledWrapper>
  )
}

export default CommunityReviewListMobile

const StyledWrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 36px;
  width: 100%;
`
